<div class="cr-header-wrapper" [class.no-border]="!showBorder" [ngClass]="cssClasses">
  <div class="header">
    @switch (headingLevel) {
      @case (1) {
        <h1>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </h1>
      }
      @case (2) {
        <h2>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </h2>
      }
      @case (3) {
        <h3>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </h3>
      }
      @case (4) {
        <h4>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </h4>
      }
      @case (5) {
        <h5>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </h5>
      }
      @case (6) {
        <h6>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </h6>
      }
      @default {
        <div>
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </div>
      }
    }

    <ng-template #headerContent>
      @if (innerHTML) {
        <div [innerHTML]="innerHTML"></div>
      } @else {
        <ng-content></ng-content>
      }
    </ng-template>
  </div>

  @if (buttonText) {
    <cr-button
      [isLoading]="isLoading"
      [isDisabled]="isDisabled"
      [requiredPermissions]="buttonRequiredPermissions"
      [routerLink]="buttonRouterLink"
      [goBack]="buttonGoBack"
      (clicked)="onClick()">
      {{ buttonText }}
    </cr-button>
  }
</div>
